import './App.css';
import HomePage from './pages/HomePage';
import 'font-awesome/css/font-awesome.min.css';

function App() {
  return (
    <div className="App">
      <HomePage/>
    </div>
  );
}

export default App;
